// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"698":"798efefc","983":"f235aff7"}[chunkId] + ".chunk.css";
};